import { useRecoilValue } from "recoil";
import { Organization } from "../models/generated/graphql";
import { flexibleFormResponseState } from "../store/flexible";

export const useLegalEntities = () => {
	const flexResponseState: { organizations: Array<Organization> } = useRecoilValue(flexibleFormResponseState);
	return flexResponseState.organizations?.map((o) => ({ label: o?.name || "", value: o?.id || "" }));
};
